import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, ReduxDispatch } from '../helpers/store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<ReduxDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
